/**
 * On backspace, if at the start of a non-paragraph, convert it back into a
 * paragraph node.
 * @param {Object} event The keyboard event
 * @param {Editor} editor The slate editor
 * @param {function} next the function that is called next
 * @returns {boolean} Whether the loop should be broken
 */
export const onBackspace = (event, editor, next) => {
  const { value } = editor;
  const { selection } = value;
  if (selection.isExpanded) return next();
  if (selection.start.offset !== 0) return next();

  const { startBlock } = value;
  if (startBlock.type === 'paragraph') return next();

  event.preventDefault();
  editor.setBlocks('paragraph');

  if (startBlock.type === 'list-item') {
    editor.unwrapBlock('bulleted-list');
    editor.unwrapBlock('numbered-list');
  }
};

/**
 * Creates a removeType Plugin
 * @returns {Object} the plugin
 */
const RemoveType = () => ({
  onKeyDown: (event, editor, next) => (event.key !== "Backspace" ? next() : onBackspace(event,editor,next))
});

export default RemoveType;
